import {
  BoardMembersOutline,
  ExecutiveOutline,
} from '@simplywallst/ui-core/icons';
import Tooltip from '@/components/Tooltip';
import { RolesWithTooltipWrapper, RolesWrapper } from './styled';

export interface RolesProps {
  boardTitle?: string;
  teamTitle?: string;
}

const Roles = ({ boardTitle, teamTitle }: RolesProps) => {
  return (
    <>
      <RolesWithTooltipWrapper>
        {teamTitle && (
          <Tooltip title={teamTitle}>
            <ExecutiveOutline />
          </Tooltip>
        )}
        {boardTitle && (
          <Tooltip title={boardTitle}>
            <BoardMembersOutline />
          </Tooltip>
        )}
      </RolesWithTooltipWrapper>
      <RolesWrapper>
        {teamTitle && <ExecutiveOutline />}
        {boardTitle && <BoardMembersOutline />}
      </RolesWrapper>
    </>
  );
};

export default Roles;
